import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';
import cx from 'clsx';
import _get from 'lodash/get';
import _set from 'lodash/set';
import _forEach from 'lodash/forEach';
import _keys from 'lodash/keys';
import _omit from 'lodash/omit';

const useStyles = makeStyles({
    root: {
        lineHeight: '24px',
    },
    clsLink: {
        cursor: 'pointer',
    },
    clsSkinnyBold: {
        fontWeight: 500,
    },
    clsLightBold: {
        fontWeight: 600,
    },
    defaultColor: {
        color: '#111E14',
    },
    clsWhiteColor: {
        color: '#FFFFFF',
    },
    clsGrayColor: {
        color: 'rgba(17, 30, 20, 0.4)',
    },
    clsMidGrayColor: {
        color: '#9B9E9C',
    },
    clsRedColor: {
        color: 'red',
    },
    clsPrimaryColor: {
        color: '#FC821F',
    },
    clsSecondaryColor: {
        color: '#1D8A8B',
    },
    clsBigCaption: {
        fontSize: '13px',
        color: 'rgba(17, 30, 20, 0.6)',
    },
    clsStrikethrough: {
        textDecoration: 'line-through',
    },
});

const AfitdTypography = props => {
    const { isHidden, children, variant = 'body1', value, ...otherProps } = _omit(props, ['classes']);
    const { clsLink, clsLightBold, clsWhiteColor, clsGrayColor, clsMidGrayColor, clsRedColor, clsBigCaption, clsStrikethrough, ...otherPropsWithoutCls } = otherProps;
    const { color } = props;
    const classes = useStyles();
    let classNames = [];

    let defn = {
        variant,
    };

    // if a prop name with prefix 'cls' and matched a class name defined in useStyles hook, override the class for the variant
    // e.g. if variant is 'h3', in order to override the styles, will have to pass in classes={ {h3: { clsPurpleColor }} }
    const propKeys = _keys(props);
    if (!color) {
        classNames.push(classes.defaultColor);
    }
    _forEach(propKeys, key => {
        if (_get(props, key) !== false) {
            const cls = _get(classes, key);
            if (cls !== undefined) {
                classNames.push(cls);
            }
        }
    });

    _set(defn, `classes.${variant}`, cx(classes.root, classNames));

    if (isHidden) {
        return null;
    } else {
        return (
            <Typography {...defn} {...otherPropsWithoutCls}>
                {value || children}
            </Typography>
        );
    }
};

export default AfitdTypography;

/*
    https://material-ui.com/components/typography/
    https://material.io/design/typography/the-type-system.html#type-scale

    h1 96px
    h2 60px
    h3 48px
    h4 34px
    h5 24px
    h6 20px
    subtitle1 16px
    subtitle2 14px
    body1 16px
    body2 14px
    button 14px
    caption 12px
    overline 12px
*/
